<template>
    <div class="ms-store-button">
        <a :id="msStoreContainerId" :href="msStoreLink"></a>
    </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { getMicrosoftStoreButton } from "@/services/download-services";

const { locale } = useI18n();

const msStoreContainerId = ref("");

const msStoreLink = "//www.microsoft.com/store/apps/9P5T2L2QM341?cid=storebadge&ocid=badge";

function launchMsStoreButtonLoad(): void {
    const promise = getMicrosoftStoreButton(locale.value);
    promise.then(resp => {
        const containerEl = document.getElementById(msStoreContainerId.value);
        while (containerEl.lastChild !== null) { containerEl.removeChild(containerEl.lastChild); }

        const svgEl = resp.data.querySelector("svg");
        if (svgEl === null) { return; }
        svgEl.setAttribute("width", "100%"); // Chrome
        containerEl.appendChild(svgEl);
    });
}

watch(locale, (newLocale: string, oldLocale: string) => {
    if (newLocale === oldLocale) { return; }
    launchMsStoreButtonLoad(); // Reset store button on language change
});

onMounted(() => {
    const tmpArray = new Uint32Array(1);
    window.crypto.getRandomValues(tmpArray);
    msStoreContainerId.value = "msstorewrapper-" + tmpArray[0].toString(16);

    launchMsStoreButtonLoad();
});
</script>

<style scoped>
.ms-store-button {
    padding: 0 4px 0 4px;
    width: 88px;
    display: flex;
    justify-content: center;
}

.ms-store-button > a {
    display: inline-flex;
}
</style>
